import LocalizedStrings from "react-localization";

export const poolMetadataStrings = new LocalizedStrings({
  en: {
    metadataTitle: "Metadata",
    date: "Date",
    id: "ID",
    sponsoredType: "Sponsored Type",
    advertiserName: "Advertiser Name",
    advertiserPaid: "Advertiser Paid",
    link: "Site Link",
    title: "Title",
  },
  fr: {
    metadataTitle: "Metadata",
    date: "Date",
    id: "ID",
    sponsoredType: "Sponsored Type",
    advertiserName: "Advertiser Name",
    advertiserPaid: "Advertiser Paid",
    link: "Site Link",
    title: "Title",
  },
});
